export default __webpack_public_path__ + "static/media/logout.fae8fc63.png";